import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Secure this car with a fully refundable holding deposit for 48 hours.", -1)
const _hoisted_2 = { className: "button-holder" }
const _hoisted_3 = {
  class: "button-solid",
  href: "/checkout"
}

import { 
		onMounted, 
		ref
	} from 'vue';
	import { useStore } from 'vuex';
	import { 
		IStoreState, 
		IVehicle, 
		IReserveResponse 
	} from '@/types';
	import { endpointPrefix } from '@/config';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle | null
	}

	

	const store = useStore<IStoreState>();
	const putResponse = ref<IReserveResponse>();

	const handleReserveCancelClick = ($event: Event) => {
		$event.preventDefault();
		store.commit('resetEnquiryModal');
	}
	const putReserve = async () => {
		await fetch(`${endpointPrefix}/api/Cart/${props.vehicle?.StockNum || ''}/1`, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({productType: 1}),
			method: 'PUT'
		}).then(response => {
			return response.json();
		}).then(json => {
			putResponse.value = json;
		}).catch(error => {
			console.log(error);
		});
	}

	onMounted((): void => {
		if (!props.vehicle?.StockNum || putResponse.value) return;
		putReserve();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("a", _hoisted_3, "Checkout", 512), [
          [_vShow, putResponse.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: "button-outline",
          onClick: handleReserveCancelClick
        }, "Cancel")
      ])
    ])
  ]))
}
}

})